define('bizzabo/models/EventAnalytics',['backbone', 'bizzabo/bzapi'], function(Backbone, BZAPI) {

    var EventAnalytics = Backbone.Model.extend({

        sync: function(method, model, options) {
            if (method == 'read') {
                BZAPI.getEventAnalytics(model.id, function(data) {
                    options.success && options.success(data, options);
                }, options.error);
            }
        },

        mockData: function () {
            var generalStats = {
                "checked-in": 1047,
                "joins": 1245,
                "leads": 403,
                "likes": 4638,
                "messages": 3562,
                "linkedin-invites": 893,
                "facebook-shares": 325,
                "linkedin-shares": 787,
                "twitter-shares": 694
            };
            this.set("general-stats", generalStats);

            var attendeeStats = {
                "leads": 403,
                "views": 6436
            };
            this.set("attendee-stats", attendeeStats);

            var exhibitorsStats = {
                "likes": 233,
                "views": 3530,
                "actions":450
            };
            this.set("exhibitors-stats", exhibitorsStats);

            var speakersStats = {
                "likes": 178,
                "views": 1023
            };
            this.set("speakers-stats", speakersStats);

            var sponsorsStas = {
                "likes": 183,
                "views": 1543,
                "actions": 114
            };
            this.set("sponsors-stats", sponsorsStas);

            var sessionsStats = {
                "likes": 250,
                "views": 8338,
                "add-to-cal": 4350
            };
            this.set("sessions-stats", sessionsStats);

        }

    });

    return EventAnalytics;

});
